import { CONTENT_INLINE_MARGIN, HEADING_MARGIN_BOTTOM } from '../../constants/styling';
import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { LockedIcon, RightIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CategoryHeader = ({
  id,
  labelKey,
  seeAll = false,
  hasAccess = true,
  tooltipKey
}) => {
  const history = useHistory();
  const {
    tabId
  } = useParams();
  const handleSeeAllClick = useCallback(() => {
    //TODO: Track event
    history.push(`${tabId}/${id}`);
  }, [history, tabId, id]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginInline: CONTENT_INLINE_MARGIN,
    marginBlockEnd: HEADING_MARGIN_BOTTOM,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-200",
        paddingBlock: seeAll ? '0' : '200',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: labelKey
        })
      }), tooltipKey && /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipKey
        }),
        alignWithText: true,
        alignItems: "center"
      }), !hasAccess && /*#__PURE__*/_jsx(LockedIcon, {})]
    }), seeAll && hasAccess && /*#__PURE__*/_jsxs(Button, {
      use: "transparent",
      onClick: handleSeeAllClick,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartLibrary.analyticsSuite.categories.seeAll"
      }), /*#__PURE__*/_jsx(RightIcon, {})]
    })]
  });
};